import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";

import HeroHomeSection from "../pages/buyer/HeroHomeSection";
import HowITWorkHomeSection from "../pages/buyer/HowITWorkHomeSection";
import WhyChooseUsHomeSection from "../pages/buyer/WhyChooseUsHomeSection";
import StaticsHomeSection from "../pages/buyer/StaticsHomeSection";
import ExploreCategoryHomeSection from "../pages/buyer/ExploreCategoryHomeSection";
import RandomProductHomeSection from "../pages/buyer/RandomProductHomeSection";
import CTAHomeSection from "../pages/buyer/CTAHomeSection";

import Seo from "../components/Seo";
import TradingChartComponent from "../pages/buyer/TradingChartComponentSection";

const Landing = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [productsReady, setProductsReady] = useState(false);

  // Scroll effect for header
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    window.prerenderReady = false;
    if (productsReady) {
      setTimeout(() => {
        window.prerenderReady = true;
        // console.log("Landing Prerender: ready = true");
      }, 500);
    }
  }, [productsReady]);

  return (
    <>
      <Seo
        title="Buy & Sell Scrap Online with Trust"
        description="ScrapTrade is the Uber of scrap trading—real-time pricing, verified buyers & sellers, and secure logistics for transparent online scrap deals."
        url="https://scraptrade.com.au"
        canonical="https://scraptrade.com.au"
        image="https://scraptrade.com.au/assets/og/scrap.jpg"
      />
      <Box
        sx={{
          backgroundColor: "#FEFDFB",
          minHeight: "100vh",
          position: "relative",
        }}
      >
        {/* Hero Section */}
        <HeroHomeSection />

        {/* Chart Section */}
        <Box sx={{ display: { xs: "none", md: "block" } }}>
          <TradingChartComponent />
        </Box>
        {/* Random Products */}
        <RandomProductHomeSection
          onProductsLoaded={() => setProductsReady(true)}
        />

        {/* How It Works Section */}
        <HowITWorkHomeSection />

        {/* Why Choose Us Section */}
        <WhyChooseUsHomeSection />

        {/* Stats Grid */}
        <StaticsHomeSection />

        {/* Explore Scrap Categories */}
        <ExploreCategoryHomeSection />

        {/* CTA Section */}
        <CTAHomeSection />
      </Box>
    </>
  );
};

export default Landing;
